import { DEFAULT_TIME_ZONE } from "../../server/rules/week";

// The company's time zone on screen (brief 1E-8): GET /api/me says it; until then, the default.
// Every date and time the screens work out themselves reads it; nothing assumes New York.

let zone = DEFAULT_TIME_ZONE;

/** Sets the company's time zone from GET /api/me (the shell, at start and on refresh). */
export function useZone(z: string | undefined): void {
  zone = z || DEFAULT_TIME_ZONE;
}

/** The company's time zone. */
export const companyZone = (): string => zone;
